import React from 'react';
import { LegalLayout, LegalSection } from './LegalLayout';

const ulStyle: React.CSSProperties = { margin: '8px 0', paddingLeft: 22 };

export const TermsOfUse: React.FC = () => {
  return (
    <LegalLayout title="Terms of Use">
      <p>
        These Terms of Use ("Terms") govern access to and use of the VERA
        platform provided by VERA Health Technologies, LLC ("VERA"). By accessing
        or using the platform, you agree to these Terms. If you use VERA on behalf
        of an organization, you represent that you are authorized to bind that
        organization.
      </p>

      <LegalSection heading="1. Eligibility & Accounts">
        <p>
          VERA is intended for use by licensed and credentialed clinical and
          administrative staff of ABA therapy practices. You are responsible for
          the accuracy of your account information, for keeping your credentials
          confidential, and for all activity under your account.
        </p>
      </LegalSection>

      <LegalSection heading="2. Acceptable Use">
        <ul style={ulStyle}>
          <li>Use the platform only for lawful, authorized clinical and business purposes.</li>
          <li>Do not access records you are not authorized to view.</li>
          <li>Do not attempt to disrupt, reverse engineer, or gain unauthorized access to the platform.</li>
          <li>Do not upload malicious code or use the platform to violate any person's privacy rights.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="3. Protected Health Information">
        <p>
          The platform is used to create and store PHI. VERA processes PHI as a
          Business Associate under a Business Associate Agreement (BAA) with each
          practice. Your organization is responsible for obtaining any patient
          consents required by law and for using the platform in compliance with
          HIPAA and applicable state regulations.
        </p>
      </LegalSection>

      <LegalSection heading="4. AI-Assisted Features">
        <p>
          VERA offers AI-assisted drafting of clinical notes and summaries. These
          outputs are drafts only. A qualified clinician must review, edit, and
          approve all documentation before it is finalized. VERA does not provide
          medical or clinical advice, and AI outputs do not replace professional
          judgment.
        </p>
      </LegalSection>

      <LegalSection heading="5. Intellectual Property">
        <p>
          The platform, including its software, design, and content, is owned by
          VERA and protected by intellectual-property laws. Clinical records and
          data you enter remain the property of your practice; you grant VERA a
          limited license to process that data solely to provide the service.
        </p>
      </LegalSection>

      <LegalSection heading="6. Service Availability">
        <p>
          We strive for high availability but do not guarantee uninterrupted
          service. We may modify, suspend, or discontinue features with reasonable
          notice. Scheduled maintenance and updates may temporarily affect access.
        </p>
      </LegalSection>

      <LegalSection heading="7. Disclaimers & Limitation of Liability">
        <p>
          The platform is provided "as is" without warranties of any kind to the
          maximum extent permitted by law. To the extent permitted by law, VERA is
          not liable for indirect, incidental, or consequential damages arising
          from use of the platform. Nothing in these Terms limits liability that
          cannot be limited under applicable law or under an executed BAA.
        </p>
      </LegalSection>

      <LegalSection heading="8. Termination">
        <p>
          We may suspend or terminate access for violation of these Terms or as
          required to protect the platform or its users. Upon termination, data
          handling follows the applicable BAA and our Privacy Policy.
        </p>
      </LegalSection>

      <LegalSection heading="9. Governing Law & Changes">
        <p>
          These Terms are governed by the laws of the state in which VERA is
          organized, without regard to conflict-of-laws principles. We may update
          these Terms; material changes will be communicated through the platform.
          Continued use after an update constitutes acceptance.
        </p>
      </LegalSection>

      <LegalSection heading="10. Contact">
        <p>
          Questions about these Terms:{' '}
          <a href="mailto:support@veraaba.com" style={{ color: '#4F6367', fontWeight: 600 }}>support@veraaba.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
};

export default TermsOfUse;
